import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const location = useLocation();

  if (!localStorage.getItem('auth')) {
    return <Navigate to={{ pathname: '/login' }} state={{ from: location }} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
